import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { formValues } from 'redux-form';
import { connect } from 'react-redux';
import { flowRight } from 'lodash';
import Title from 'components/Title';
import FormGroup from 'components/form/Group';
import Card from './InvestorProfileCard';
import './InvestorProfile.css';
import Error from '../../Error';
import Icon from '../../../common/components/Icon';
import { setInvestorProfileSource } from '../../../actions';
import withRouter from '../../withRouter';

const InvestorProfile = ({
    familySituation,
    firstName,
    lastName,
    partnerFirstName,
    partnerLastName,
    investorProfiles,
    investorProfilesError,
    submitSucceeded,
    displayEntity,
    dualRip,
    setSource,
    navigate,
    params: { id },
}) => {
    const withPartner = (['married', 'partner'].includes(familySituation)
        || ('cohabitation' === familySituation && dualRip));
    const clientData = get('client', investorProfiles);
    const partnerData = get('partner', investorProfiles);

    const contractualPartner = ['married', 'partner'].includes(familySituation);
    const toInvestorProfile = () => {
        // persist the entry point to come back
        setSource(`/rip/${id}/profil-client`, 'Retour à l\'édition du RIP');

        // then move on the investor profile
        return navigate(`/rip/${id}/investorProfile/client&partner`);
    };

    return (
        <FormGroup>
            <Title>Définissez votre profil investisseur à l&apos;aide du questionnaire de risque*</Title>
            <Fragment>
                <div className="investor-profile-cards">
                    <Card
                        firstName={firstName}
                        lastName={lastName}
                        target="client"
                        data={clientData}
                        fieldName="allowChangingInvestorProfile"
                        withTitle={withPartner}
                        displayEntity={displayEntity}

                        investorProfileDuo={contractualPartner}
                        investorProfiles={investorProfiles}

                    />
                    {withPartner && (
                        <Card
                            firstName={partnerFirstName}
                            lastName={partnerLastName}
                            target="partner"
                            data={partnerData}
                            fieldName="partnerAllowChangingInvestorProfile"
                            withTitle
                            displayEntity={displayEntity}
                            investorProfileDuo={contractualPartner}
                        />
                    )}
                </div>
                {contractualPartner && (
                    <div className="button-investor-contractual-partner">
                        <button onClick={toInvestorProfile}>
                            <Icon icon="pencil" className="fa-fw" /> Accéder aux questionnaires
                        </button>
                    </div>
                )}
            </Fragment>

            {submitSucceeded && investorProfilesError && <Error errortext="Vous devez remplir le questionnaire." forceerror />}
            <p className="help-block">
                L&apos;ensemble des questions et vos réponses sont tenues à votre disposition par
                l&apos;intermédiaire de votre conseiller.
            </p>
        </FormGroup>
    );
};

InvestorProfile.propTypes = {
    displayEntity: PropTypes.shape({}),
    familySituation: PropTypes.string,
    firstName: PropTypes.string.isRequired,
    investorProfiles: PropTypes.shape({}),
    investorProfilesError: PropTypes.string,
    lastName: PropTypes.string.isRequired,
    partnerFirstName: PropTypes.string,
    partnerLastName: PropTypes.string,
    submitSucceeded: PropTypes.bool,
    dualRip: PropTypes.bool,
    setSource: PropTypes.func,
    navigate: PropTypes.func,
    params: PropTypes.shape({
        id: PropTypes.string,
    }),
};

InvestorProfile.defaultProps = {
    familySituation: null,
    partnerFirstName: null,
    investorProfiles: {},
};

const mapStateToProps = (state) => ({
    investorProfilesError: get('investorProfiles', state.form['rip-profil'].syncErrors),
    submitSucceeded: state.form['rip-profil'].submitSucceeded,
});

export default flowRight([
    formValues({
        firstName: 'firstName',
        lastName: 'lastName',
        partnerLastName: 'partnerLastName',
        partnerFirstName: 'partnerFirstName',
        familySituation: 'familySituation',
        investorProfiles: 'investorProfiles',
        dualRip: 'dualRip',
    }),
    withRouter,
    connect(mapStateToProps),
    connect(null, { setSource: setInvestorProfileSource }),
])(InvestorProfile);
